//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import UsuarioCobranzas from '@/api/promotores/usuarios/cobranzas.api'
export default {
  data() {
    return {
      cobranzas: [],
      visible_columns: [
        'cuenta',
        'nombre',
        'direccion',
        'usuario',
        'status',
        'created_at',
      ],
      columns: [
        {
          name: "cuenta",
          label: "Cuenta ID",
          field: "cuenta",
          align: "left",
          sortable: true,
          classes: "bg-grey-2 ellipsis",
          headerClasses: "bg-primary text-white",
          required: true,
        },
        {
          name: "nombre",
          label: "Nombre",
          field: "nombre",
          align: "left",
          sortable: true,
          required: true,
        },
        {
          name: "direccion",
          label: "Dirección",
          field: "direccion",
          align: "left",
        },
        {
          name: "telefono",
          label: "Teléfono",
          field: "telefono",
          align: "left",
        },
        {
          name: "email",
          label: "E-mail",
          field: "email",
          align: "left",
        },
        { name: "adeudo", label: "Adeudo", field: "adeudo", align: "left", format: this.currency, },
        {
          name: "recompensa",
          label: "Recompensa",
          field: "recompensa",
          align: "left",
          format: this.currency,
        },
        {
          name: "calificacion",
          label: "Calificación",
          field: "calificacion",
          align: "left",
        },
        {
          name: "status",
          label: "Estado",
          field: "status",
          align: "left",
          sortable: true,
          required: true,
        },
        {
          name: "created_at",
          label: "Creación",
          field: "created_at",
          align: "left",
          sortable: true,
        },
      ],
      loading: false,
      status: [
        "creada",
        "aceptada", 
        "en proceso",
        "concluida",
        "cerrada",
      ],
    }
  },

  mounted() {
    this.loadCobranzas();
  },

  methods: {
    async loadCobranzas() {
      try {
        this.loading = true
        this.cobranzas = await UsuarioCobranzas.all(this.$route.params.promotor)
      } finally {
        this.loading = false
      }
    },

    async updateStatus({ _id, status }) {
      try {
        this.loading = true;
        await UsuarioCobranzas.update(_id, { status });
      } finally {
        this.loading = false;
      }
    },

    async rating({ _id, calificacion }) {
      try {
        this.loading = true;
        await UsuarioCobranzas.update(_id, { calificacion });
      } finally {
        this.loading = false;
      }
    },
  }
}
